import { put, select, call, takeLatest } from "redux-saga/effects";
import { extend, isEmpty } from 'underscore';

import DatagraphHelper from "../../../Utils/DatagraphHelper";
import UserInfoUtil from 'UserInfoUtil';
import BaseServiceApi from 'BaseServiceApi';

import { PriceChartConstants } from "../../../Constants/PriceChartConstants.js";
import { RiPanelConstants } from "../../../Constants/RiPanelConstants";
import GraphType from "GraphType";

import { getAINewsStates, getDatagraphStates, getTimeLineEndDate, priceChartReducerselect } from "../../../Reducers/NavDataGraph/TabDataGraph/selectors.js";
import { getRiPanelAIState } from "../../../Reducers/NavDataGraph/RelatedInfoPanel/selectors.js";

import SettingsStore from "SettingsStore";
import SymbolType from "SymbolType";
import { AI_FUTURE_EVENT_TYPES, AINewsConstants } from "../../../Constants/AINewsConstants.js";
import { initTimeLine } from "../../../Actions/TabDataGraphAction.js";
import DateHelper from "DateHelper";
import aiNewsApi from "../../../ServiceApi/Apis/AINewsApi.js";
import consoleStore from "../../../Stores/ConsoleWindow/ConsoleStore.js";
import moment from "moment";
import StringUtil from "StringUtil";

const { ActionTypes } = RiPanelConstants;
extend(ActionTypes, PriceChartConstants.ActionTypes);
const { ActionTypes: AINewsActionTypes } = AINewsConstants;

const EntitlementType = BaseServiceApi.rayData["EntitlementType"];

function getChangeValue(value, chnage){
    return value + (value * chnage)
}

function addDuration(date, duration, unit){
    if (duration <= 0) return date;
    return date.add(duration, unit);
}

function getMatchingPercentile(allPoints, startTrendPoint, endTrendPoint, latestTrend, trendPoints, durationLines, scale, lineColor, textColor, lineType, periodicity){
    try {
        let targetValue = startTrendPoint.graphData.Low;
        const upTrend = endTrendPoint.upTrend;
        if(upTrend){
            targetValue = getChangeValue(startTrendPoint.graphData.Low, latestTrend.change)
        }
        else{
            targetValue = getChangeValue(startTrendPoint.graphData.High, latestTrend.change);
        }
        
        let targetPoint = null, i = startTrendPoint.dataIndex;
        for(; i >= 0; i--){
            const point = allPoints[i]
            if(upTrend && point.graphData.High >= targetValue || !upTrend && point.graphData.Low <= targetValue){
                point.dataIndex = i;
                targetPoint = point;
                break;
            }
        }
        const latestDurationIndex = startTrendPoint.dataIndex - latestTrend.duration;
        let targetDate = null
        if(latestDurationIndex < 0){
            let momentDate = moment(endTrendPoint.Date)
            const day = momentDate.day();
            let remainingDurations = Math.abs(latestDurationIndex - endTrendPoint.dataIndex)
            if (periodicity === GraphType.Daily){
                remainingDurations -= (5- day);
                momentDate = addDuration(momentDate, 5 - day, "d");
                const remainingWeeks = Math.floor(remainingDurations / 5);
                momentDate = addDuration(momentDate, remainingWeeks, "w");
                remainingDurations = remainingDurations % 5;
                remainingDurations = remainingDurations > 0 ? remainingDurations + 2 : 0; // +2 to skip weekend
            }

            const period = periodicity === GraphType.Monthly ? "M" : periodicity === GraphType.Weekly ? "w" : "d";
            targetDate = addDuration(momentDate, remainingDurations, period).format("MMMM D, YYYY")
        }
        else {
            const date = allPoints[latestDurationIndex].Date
            targetDate = moment(date).format("MMMM D, YYYY")
        }
        
        durationLines.push({
            showLine: 0 <= latestDurationIndex,
            durationX: startTrendPoint.xAxis + 4 * latestTrend.duration,
            lineColor,
            duration: latestDurationIndex,
            targetValue,
            lineType, 
            targetDate
        })
        if(targetPoint){
            trendPoints.push({
                x1: startTrendPoint.xAxis,
                y1: startTrendPoint.upTrend ? startTrendPoint.yHigh : startTrendPoint.yLow,
                x2: targetPoint.xAxis,
                y2: upTrend ? targetPoint.yHigh : targetPoint.yLow,
                isDotted: false,
                textColor,
                lineColor,
                lineType,
            })
        }
        else if (latestDurationIndex < 0){
            // trendPoints.push({
            //     x1: startTrendPoint.xAxis,
            //     y1: startTrendPoint.upTrend ? startTrendPoint.yHigh : startTrendPoint.yLow,
            //     x2: endTrendPoint.xAxis,
            //     y2: upTrend ? endTrendPoint.yHigh : endTrendPoint.yLow,
            //     isDotted: false,
            //     lineColor,
            //     lineType
            // })
            trendPoints.push({
                x1: endTrendPoint.xAxis,
                y1: endTrendPoint.upTrend ? endTrendPoint.yHigh : endTrendPoint.yLow,
                x2: endTrendPoint.xAxis + 4 * Math.abs(latestDurationIndex - endTrendPoint.dataIndex),
                y2: scale.ComputeY(targetValue),
                isDotted: true,
                textColor,
                lineColor,
                lineType,
            })
        }
        return null;
    } catch (error) {
        console.error("Error occured in RiPanelAI.js, getMatchingPercentile", error);
    }
}

function* getPercentileLineData({ zigzagIndicatorData, declines, rallies }) {
    try {
        const { HiLowPoints, isLineChart, scale, periodicity } = yield select(priceChartReducerselect);
        const { SymbolInfo } = yield select(getDatagraphStates);
        const isPreIPO = SymbolInfo.SymTypeEnum === SymbolType.PREIPO;

        if (!zigzagIndicatorData || zigzagIndicatorData.length < 2 || isEmpty(declines) || isEmpty(rallies) ||
            !HiLowPoints.allPoints || isLineChart || isPreIPO) 
            return {
            percentileLines: [],
            durationLines: [],
        };

        const allPoints =  HiLowPoints.allPoints;

        const lastPoint = zigzagIndicatorData[0];
        const latestTrend = lastPoint.upTrend ? rallies : declines
        const secondLastPoint = zigzagIndicatorData[1];
        const percentileLines = [];
        const durationLines = []
        getMatchingPercentile(
            allPoints,
            secondLastPoint,
            lastPoint,
            {change: latestTrend.pct90th, duration: latestTrend.pct90Duration },
            percentileLines,
            durationLines,
            scale, 'dg-zigzag90PctLine', 'dg-zigzag90PctText',
            '90th Percentile',
            periodicity
        )
        getMatchingPercentile(
            allPoints,
            secondLastPoint,
            lastPoint,
            {change: latestTrend.median, duration: latestTrend.medianDuration },
            percentileLines,
            durationLines,
            scale, 'dg-zigzagMedianLine', 'dg-zigzagMedianText',
            'Median',
            periodicity)
        
        return {
            percentileLines,
            durationLines,
        };
    } catch (error) {
        console.error("Error occured in RiPanelAI.js, getPercentileLineData", error);
        return {};
        //throw error;
    }
}

function* updateZZSwingSize({ item }) {
    try {
        const { majorPeriodicity } = yield select(priceChartReducerselect);
        let { 
            aiSettings, zigzagIndicatorData, declines,
            rallies, selectedSwingSize,
            percentileLines, durationLines,
            swingSizeDeclines, swingSizeRallies,
            swingSizeSummaries, swingSizePercentiles,
            swingSizeZigzagHistoy
        } = yield select(getRiPanelAIState);
        const { swingSize } = aiSettings.zigzagIndicator;
        if (item.value === 0) {
            swingSize[GraphType.Daily] = 10;
            swingSize[GraphType.Weekly] = 15;
            swingSize[GraphType.Monthly] = 20;
        } else {
            swingSize[item.periodicity] = item.value;
        }

        declines= swingSizeDeclines[swingSize[majorPeriodicity]] || {};
        rallies= swingSizeRallies[swingSize[majorPeriodicity]] || {};

        if (item.periodicity === 'All' || majorPeriodicity === item.periodicity) {
            zigzagIndicatorData = yield call(initZigzagIndicatorData, swingSize[majorPeriodicity]);
            const result = yield call(getPercentileLineData, { 
                zigzagIndicatorData, 
                declines,
                rallies
            })
            percentileLines = result.percentileLines;
            durationLines = result.durationLines;
        }

        yield put({
            type: ActionTypes.ZZ_INDICATOR_DATA_READY,
            newState: { 
                zigzagIndicatorData, 
                aiSettings: Object.assign({}, aiSettings), 
                selectedSwingSize: swingSize[majorPeriodicity] || selectedSwingSize, 
                majorPeriodicity,
                declines,
                rallies,
                summary: swingSizeSummaries[swingSize[majorPeriodicity]] || {},
                percentile: swingSizePercentiles[swingSize[majorPeriodicity]] || {},
                zigzagHistory: swingSizeZigzagHistoy[swingSize[majorPeriodicity]] || {},
                percentileLines,
                durationLines,
            }
        });
        
        SettingsStore.saveSettings();
    }
    catch (error) {
        console.error("Error occured in RiPanelAI.js, updateZZSwingSize", error);
    }
}

function* initZigzagIndicatorData(selectedSwingSize) {
    try {
        const {
            swingSizeZigzagHistoy
        } = yield select(getRiPanelAIState);
        const { HiLowPoints } = yield select(priceChartReducerselect);
        const allPoints = HiLowPoints.allPoints;

        if (!allPoints || allPoints.length === 0 || !swingSizeZigzagHistoy[selectedSwingSize]) {
            return [];
        }
        let pointIndex = allPoints.findIndex((item=> {
            
            return item.Date.getTime() === swingSizeZigzagHistoy[selectedSwingSize][0].date.getTime()
        }
        ));
        const zigzagIndicatorData = [];
        for (const item of swingSizeZigzagHistoy[selectedSwingSize]) {
            if (item.percentValue === 0) {
                    pointIndex = allPoints.length - 1;
                }
                if(allPoints[pointIndex] && allPoints[pointIndex].Date.getTime() === item.date.getTime() || item.percentValue === 0 && pointIndex === (allPoints.length - 1)){
                    item.xAxis = allPoints[pointIndex].xAxis;
                    item.yHigh = allPoints[pointIndex].yHigh;
                    item.yLow = allPoints[pointIndex].yLow;
                    item.graphData = allPoints[pointIndex].graphData;
                    item.yPrice = allPoints[pointIndex].yPrice;
                    item.dataIndex = pointIndex;
                }
                else{
                    break;
                }
                pointIndex += item.percentDuration;
                zigzagIndicatorData.push(item);
        }
        return zigzagIndicatorData;
    } catch (error) {
        console.error(`Error occured in RiPanelAI.js, initZigzagIndicatorData ${error}`);
        return [];
    }
}

function* processZigzagIndicatorData() {
    try {
        const isZigzagBasicEntitled = UserInfoUtil.IsUserEntitled(EntitlementType.ZIG_ZAG_INDICATOR_Entitlement);
        const isZigzagAIEntitled = UserInfoUtil.IsUserEntitled(EntitlementType.ZIGZAG_AI_INDICATOR_Entitlement);

        if (isZigzagBasicEntitled || isZigzagAIEntitled) {
            const { majorPeriodicity } = yield select(priceChartReducerselect);
            const { 
                swingSizeDeclines, swingSizeRallies,
                swingSizeSummaries, swingSizePercentiles,
                swingSizeZigzagHistoy
            } = yield select(getRiPanelAIState);
            /* Retrieve the settings according to the instrument type */
            const consoleSettings = SettingsStore.getConsoleSettings();
            const aiSettings = DatagraphHelper.getSettingsObject(consoleSettings, consoleSettings.NavDatagraphSettings.RelatedInformationSettings).AiSettings;
            let zigzagIndicatorData = [], selectedSwingSize = 15, percentileLines = [], durationLines = [];

            selectedSwingSize = aiSettings?.zigzagIndicator?.swingSize[majorPeriodicity] || selectedSwingSize;
            const declines = swingSizeDeclines[selectedSwingSize] || {};
            const rallies = swingSizeRallies[selectedSwingSize] || {};

            /* Intraday, Quarterly and Annual periodicities are currently out of scope */
            if (!(majorPeriodicity === GraphType.Intraday || majorPeriodicity === GraphType.Quarterly || majorPeriodicity === GraphType.Annual)) {
                
                zigzagIndicatorData = yield call(initZigzagIndicatorData, selectedSwingSize);
                const result = yield call(getPercentileLineData, { zigzagIndicatorData, declines, rallies })
                
                percentileLines = result.percentileLines;
                durationLines = result.durationLines;

            }

            yield put({
                type: ActionTypes.ZZ_INDICATOR_DATA_READY,
                newState: { 
                    zigzagIndicatorData, 
                    aiSettings, 
                    activePeriodLineSettings: aiSettings?.zigzagIndicator?.lineStyle[majorPeriodicity], 
                    selectedSwingSize, 
                    majorPeriodicity, 
                    isZigzagAIEntitled,
                    percentileLines,
                    durationLines,
                    declines,
                    rallies,
                    summary: swingSizeSummaries[selectedSwingSize] || {},
                    percentile: swingSizePercentiles[selectedSwingSize] || {},
                    zigzagHistory: swingSizeZigzagHistoy[selectedSwingSize] || {},
                }
            });
        }
    } catch (error) {
        console.log(`Error occured in RiPanelAI.js, processZigzagIndicatorData ${error}`)
    }
}

function* updateFutureEventVisibilitySettings(payload) {
    try {
        const { nodeCount, InitialBufferSize } = yield select(getDatagraphStates);
        const consoleSettings = SettingsStore.getConsoleSettings();
        const aiSettings = DatagraphHelper.getSettingsObject(consoleSettings, consoleSettings.NavDatagraphSettings.RelatedInformationSettings).AiSettings;
        aiSettings.futureEvent.isVisible = payload.isVisible;
        SettingsStore.saveSettings();
        yield put({
            type: ActionTypes.UPDATE_FUTURE_EVENT_SETTINGS,
            aiSettings: { ...aiSettings, futureEvent: { ...aiSettings.futureEvent, isVisible: payload.isVisible } }
        });
        const lastDate = yield select(getTimeLineEndDate);
        yield put(initTimeLine(lastDate, nodeCount, InitialBufferSize, false, false));
    } catch (error) {
        console.error("Error occured in RiPanelAI.js, updateFutureEventVisibilitySettings", error);
    }
}

function* updateFutureEventGutterSettings(payload) {
    try {
        const { nodeCount, InitialBufferSize } = yield select(getDatagraphStates);
        const consoleSettings = SettingsStore.getConsoleSettings();
        const aiSettings = DatagraphHelper.getSettingsObject(consoleSettings, consoleSettings.NavDatagraphSettings.RelatedInformationSettings).AiSettings;
        aiSettings.futureEvent.gutterSize[payload.item.periodicity] = payload.item.value;
        SettingsStore.saveSettings();
        yield put({
            type: ActionTypes.UPDATE_FUTURE_EVENT_SETTINGS,
            aiSettings: { ...aiSettings, futureEvent: { ...aiSettings.futureEvent, gutterSize: { ...aiSettings.futureEvent.gutterSize, [payload.item.periodicity]: payload.item.value } } }
        });
        const lastDate = yield select(getTimeLineEndDate);
        yield put(initTimeLine(lastDate, nodeCount, InitialBufferSize, false, false));
    } catch (error) {
        console.error("Error occured in RiPanelAI.js, updateFutureEventGutterSettings", error);
    }
}

function* updateUseForwardEpsRps(payload) {
    try {
        const consoleSettings = SettingsStore.getConsoleSettings();
        const aiSettings = DatagraphHelper.getSettingsObject(consoleSettings, consoleSettings.NavDatagraphSettings.RelatedInformationSettings).AiSettings;
        const { nodeCount, InitialBufferSize, periodicity, viewsSettings } = yield select(getDatagraphStates);
        const earningLineSetting = viewsSettings.EarningLineSetting ? viewsSettings.EarningLineSetting[periodicity] : undefined;
        const revenueLineSetting = viewsSettings.RevenueLineSetting ? viewsSettings.RevenueLineSetting[periodicity] : undefined;
        aiSettings.futureEvent.useEpsRpsSettings = payload.value;
        SettingsStore.saveSettings();
        yield put({
            type: ActionTypes.UPDATE_FUTURE_EVENT_SETTINGS,
            aiSettings: { ...aiSettings, futureEvent: { ...aiSettings.futureEvent, useEpsRpsSettings: payload.value  } }
        });
        const fCQtrEstCount = earningLineSetting === undefined || revenueLineSetting === undefined || (!earningLineSetting.IsVisible && !revenueLineSetting.IsVisible) ? 0 : earningLineSetting.NumOfQuarters;
        if (aiSettings.futureEvent.gutterSize[periodicity] !== fCQtrEstCount) {
            const lastDate = yield select(getTimeLineEndDate);
            yield put(initTimeLine(lastDate, nodeCount, InitialBufferSize, false, false));
        }
    } catch (error) {
        console.error("Error occured in RiPanelAI.js, updateUseForwardEpsRps", error);
    }
}

function* updateFutureEventsAllowed(payload) {
    try {
        const consoleSettings = SettingsStore.getConsoleSettings();
        const aiSettings = DatagraphHelper.getSettingsObject(consoleSettings, consoleSettings.NavDatagraphSettings.RelatedInformationSettings).AiSettings;
        const { futureEventsOriginal, futureEventsResponse } = yield select(getAINewsStates);
        const futureEvent = aiSettings.futureEvent.eventsAllowed[payload.futureEvent] ?? true;
        const futureEventsAllowed = aiSettings.futureEvent.eventsAllowed;
        futureEventsAllowed[payload.futureEvent] = !futureEvent;
        SettingsStore.saveSettings();
        yield put({
            type: ActionTypes.UPDATE_FUTURE_EVENT_SETTINGS,
            aiSettings: { ...aiSettings, futureEvent: { ...aiSettings.futureEvent, eventsAllowed: futureEventsAllowed } }
        });
        const filteredFutureEvents = futureEventsOriginal.filter(
            (event) =>
                (futureEventsAllowed.Critical && event.type === AI_FUTURE_EVENT_TYPES.CRITICAL) ||
                (futureEventsAllowed.CompanyNews && event.type === AI_FUTURE_EVENT_TYPES.COMPANY_NEWS) ||
                (futureEventsAllowed.ProductNews && event.type === AI_FUTURE_EVENT_TYPES.PRODUCT_NEWS) ||
                (futureEventsAllowed.Industry && event.type === AI_FUTURE_EVENT_TYPES.INDUSTRY) ||
                (futureEventsAllowed.GovernmentRegulations && event.type === AI_FUTURE_EVENT_TYPES.GOVERNMENT_REGULATORY)
        );
        yield put({
            type: AINewsActionTypes.UPDATE_FUTURE_EVENTS,
            states: {
                futureEvents: filteredFutureEvents,
                futureEventsOriginal,
                futureEventsResponse
            }
        });
    } catch (error) {
        console.error("Error occured in RiPanelAI.js, updateFutureEventsAllowed", error);
    }
}

function* getAiStatisticsData({ symbol, periodicity, graphType, beginDate, endDate }) {
    try {
        // const { aiSettings } = yield select(getRiPanelAIState);
        if (!symbol || !periodicity) return;
        const payload = {
            symbol: symbol,
            periodicity: graphType,
            startDate: beginDate,
            endDate: endDate
        };
        const response = yield call(aiNewsApi.getAiStatisticsRequest, payload);

        const consoleSettings = SettingsStore.getConsoleSettings();
        const aiSettings = DatagraphHelper.getSettingsObject(consoleSettings, consoleSettings.NavDatagraphSettings.RelatedInformationSettings).AiSettings;
        const swingSize = aiSettings?.zigzagIndicator?.swingSize || {};
        if (response && response.responseHeader.errorCode !== 404) {
            const swingSizeDeclines = {}
            const swingSizeRallies = {}
            const swingSizeSummaries = {}
            const swingSizePercentiles = {}
            const swingSizeZigzagHistoy = {}
            response.declines.forEach((item) => {
                swingSizeDeclines[item.swingSize] = item;
            })
            response.rallies.forEach((item) => {
                swingSizeRallies[item.swingSize] = item;
            })
            response.summary.forEach((item) => {
                swingSizeSummaries[item.swingSize] = item;
            })
            response.percentile.forEach((item) => {
                swingSizePercentiles[item.swingSize] = item;
            })
            response.history.forEach((item) => {
                if(swingSizeZigzagHistoy[item.swingSize] === undefined){
                    swingSizeZigzagHistoy[item.swingSize] = [];
                }
                item.osid = StringUtil.convertFromLongValueToInt(item.osid);
                item.date = DateHelper.getPSTFromLong(item.date)
                item.upTrend = item.percentValue > 0;
                item.change = item.percentValue;
                item.Date = item.date;
                swingSizeZigzagHistoy[item.swingSize].push(item);
            })
            for (const key in swingSizeZigzagHistoy) {
                const arrayLength = swingSizeZigzagHistoy[key].length
                if(arrayLength >= 2){
                    swingSizeZigzagHistoy[key][arrayLength - 1].upTrend = !swingSizeZigzagHistoy[key][arrayLength - 2].upTrend;
                }
            }
            const zigzagIndicatorData = yield call(initZigzagIndicatorData, swingSize[periodicity])
            yield put({
                type: ActionTypes.AI_STATISTICS_DATA_READY,
                declines: swingSizeDeclines[swingSize[periodicity]] || {},
                rallies: swingSizeRallies[swingSize[periodicity]] || {},
                summary: swingSizeSummaries[swingSize[periodicity]] || {},
                percentile: swingSizePercentiles[swingSize[periodicity]] || {},
                zigzagHistory: swingSizeZigzagHistoy[swingSize[periodicity]] || {},
                message: "",
                swingSizeRallies,
                swingSizeDeclines,
                swingSizePercentiles,
                swingSizeSummaries,
                swingSizeZigzagHistoy,
                zigzagIndicatorData
            });
        }
    } catch (error) {
        yield put({
                type: ActionTypes.AI_STATISTICS_DATA_READY,
                declines: {},
                rallies: {},
                summary: {},
                percentile: {},
                swingSizeSummaries: {},
                zigzagHistory: {},
                message: "",
                swingSizeRallies: {},
                swingSizeDeclines: {},
                swingSizePercentiles: {},
                swingSizeZigzagHistoy: {},
                zigzagIndicatorData: []
            });
        console.log(`Error occured in RiPanelAI.js, getAiStatisticsData ${error}`);
    }
}

/*** watchers ***/

export function* watchInitZZIndicator() {
    yield takeLatest(ActionTypes.PRICE_DATA_READY, processZigzagIndicatorData)
}

export function* watchUpdateZZSwingSize() {
    yield takeLatest(ActionTypes.UPDATE_ZZ_INDICATOR_SWING_SIZE, updateZZSwingSize)
}

export function* watchUpdateFutureEventsAllowed() {
    yield takeLatest(ActionTypes.UPDATE_FUTURE_EVENTS_ALLOWED, updateFutureEventsAllowed);
}

export function* watchUpdateFutureEventVisibilitySettings() {
    yield takeLatest(ActionTypes.UPDATE_FUTURE_EVENT_VISIBILITY_SETTINGS, updateFutureEventVisibilitySettings);
}

export function* watchUpdateFutureEventGutterSettings() {
    yield takeLatest(ActionTypes.UPDATE_FUTURE_EVENT_GUTTER_SETTINGS, updateFutureEventGutterSettings);
}

export function* watchUpdateUseForwardEpsRps() {
    yield takeLatest(ActionTypes.UPDATE_USE_FORWARD_EPS_RPS, updateUseForwardEpsRps);
}
export function* watchGetAiStatisticsData() {
    yield takeLatest(ActionTypes.GET_AI_STATISTIC_DATA, getAiStatisticsData)
}